import React, { Fragment, useState } from "react";
import { Card, Col, Button, Alert } from 'react-bootstrap';
import '../../../../styles/balanco.scss'
import moment from "moment";

const Requisicao = (props) => {


    const [esic, setEsic] = useState(props.requisicao.esic)

    moment.locale('pt');
    moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ]
    });
    const dataCad = moment(props.requisicao.dataCad).utc(false).format("DD/MM/YYYY");
    const dataAtualiza = moment(props.requisicao.dataAtualiza).utc(false).format("DD/MM/YYYY");
    const dataPrev = moment(props.requisicao.dataPrevisao).utc(false).format("DD/MM/YYYY");

    const deletar = async (id) => {
        props.deletar(id)
        await props.fetchRequisicoesIn()
    }

    const corrigir = async (id) => {
        props.corrigir(id)
        await props.fetchRequisicoesIn()
    }

    const editar = async (id) => {
        props.editar(id)
    }

    var msg = 'Olá, ' + props.requisicao.nome + ' vim comunicar a respeito da sua requisição Nº' + props.requisicao._id + ' na Prefeitura Municipal de Macuco';
    var classes = 0

    switch (props.requisicao.situacao) {
        case "Pendente":
            classes = "card-list redd";
            break;
        case "Resolvido":
        case "Encerrado":
            classes = "card-list grre";
            break;
        default:
            classes = "card-list yell";
    }

    return (
        <Fragment>
            <Col>
                <Card className={classes}>
                    <Card.Body>
                        <Card.Title className="cabeca-card" key={props.key}>Requisição Nº{props.requisicao._id}</Card.Title>
                        <p>Munícipe: <strong>{props.requisicao.nome}</strong></p>
                        <p>Situação: <strong>{props.requisicao.situacao}</strong></p>
                        <p>Endereço: <strong>{props.requisicao.endereco}</strong></p>
                        {props.requisicao.email ? <p>E-mail: <strong>{props.requisicao.email}</strong></p> : null}
                        <p>Descrição: {props.requisicao.descricao}</p>
                        <p>Data de Cadastro: {dataCad}</p>
                        {props.requisicao.dataPrevisao ?
                            <p>Data máxima para resposta: {dataPrev}</p>
                            : null}
                        <p>Última Atualização: {dataAtualiza}</p>
                        {props.requisicao.sigilo ?
                            <p><Alert variant="danger">Informação sigilosa</Alert></p>
                            : null}
                        {props.requisicao.desclassificada ?
                            <p><Alert variant="warning">Informação desclassificada</Alert></p>
                            : null}
                        {props.requisicao.foto ?
                            <a target="_blank" rel="noreferrer" href={`https://prefeituramacuco.rj.gov.br${props.requisicao.foto}`}>Ver Foto</a> : ''
                        }
                    </Card.Body>
                    <hr />
                    <Button type="button" className="botao-leis" onClick={() => editar(props.requisicao._id)} variant='primary'>Responder Requisição</Button>
                    {props.requisicao.telefone ?
                        <a target="_blank" rel="noreferrer" href={`https://api.whatsapp.com/send/?phone=55${props.requisicao.telefone}&text=${encodeURIComponent(msg)}`}>
                            <Button type='button' className="botao-leis" variant='success'>
                                Chamar no WhatsApp</Button>
                        </a> : ''}
                    <Button type='button' className="botao-leis" onClick={() => corrigir(props.requisicao._id)} variant='danger'>{esic === true ? <span>Mover para Administra</span> : <span>Mover para E-sic</span>}</Button>
                    <Button type='button' className="botao-leis" onClick={() => deletar(props.requisicao._id)} variant='danger'>Excluir</Button>
                </Card>
            </Col>
        </Fragment >)
}

export default Requisicao;